import React from 'react'
import { Outlet } from 'react-router-dom'

function MainInvoice() {
  return (
      <div>
          <Outlet/>
        </div>
  )
}

export default MainInvoice
